(function ($, Global) {
    function CountdownComponent() {
        // Déclaration class objet
    }

    CountdownComponent.prototype.initEvents = function () {
		this.publishers();
	}

    CountdownComponent.prototype.publishers = function () {
        var offerEndDate = $('.offer-countdown').data('date-offer');
        var countDownDate = new Date(offerEndDate).getTime();

        var x = setInterval(function () {
            var now = new Date().getTime();
            var distance = countDownDate - now;

            $('.offer-countdown #countdown-days').html(("0" + Math.floor(distance / (1000 * 60 * 60 * 24))).slice(-2));
            $('.offer-countdown #countdown-hours').html(("0" + Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(-2) );
            $('.offer-countdown #countdown-minutes').html(("0" + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).slice(-2));
            $('.offer-countdown #countdown-seconds').html(("0" + Math.floor((distance % (1000 * 60)) / 1000)).slice(-2));

            if (distance < 0) {
                clearInterval(x);
                $('.offer-countdown').html("EXPIRED");
            }
        }, 1000);
	}

    Global.CountdownComponent = CountdownComponent;
}(jQuery, window));